<div class="barcode-container">
  <svg id="barcode" [ngClass]="{ redeem: isRedeem , 'coupon-code': couponCode  }"></svg>
  <div class="code">
    <ng-container *ngIf="isRedeem; else earn">
      <span class="black">{{ formattedCode }} </span>
      <span class="red">{{ formattedOtp }}</span>
    </ng-container>
    <ng-template #earn>
      <span *ngIf="!couponCode">{{ formattedCode }}</span>
      <span class="black" *ngIf="couponCode">{{ couponCode }}</span>
    </ng-template>
  </div>
</div>
